import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    GET_OCCUPANTS,
    GET_OCCUPANTS_SUCCESS,
    GET_OCCUPANTS_FAILURE,
    GET_OCCUPANT_DETAILS,
    GET_OCCUPANT_DETAILS_SUCCESS,
    GET_OCCUPANT_DETAILS_FAILURE,
    CREATE_OCCUPANT,
    CREATE_OCCUPANT_SUCCESS,
    CREATE_OCCUPANT_FAILURE,
    UPDATE_OCCUPANT,
    UPDATE_OCCUPANT_SUCCESS,
    UPDATE_OCCUPANT_FAILURE,
    DELETE_OCCUPANT,
    DELETE_OCCUPANT_SUCCESS,
    DELETE_OCCUPANT_FAILURE,
    UPLOAD_OCCUPANT_DOCUMENT,
    UPLOAD_OCCUPANT_DOCUMENT_SUCCESS,
    UPLOAD_OCCUPANT_DOCUMENT_FAILURE,
    DELETE_OCCUPANT_DOCUMENT,
    DELETE_OCCUPANT_DOCUMENT_SUCCESS,
    DELETE_OCCUPANT_DOCUMENT_FAILURE,
    LIST_OCCUPANT_DOCUMENTS,
    LIST_OCCUPANT_DOCUMENTS_SUCCESS,
    LIST_OCCUPANT_DOCUMENTS_FAILURE
} from '../../../actions/index.types';
import {
    getOccupantsReq,
    getOccupantDetailsReq,
    createOccupantReq,
    updateOccupantReq,
    deleteOccupantReq,
    uploadOccupantDocumentReq,
    deleteOccupantDocumentReq,
    listOccupantDocumentsReq
} from '../../../../axios/request/SocietyPortal/OccupantReqs/OccupantReqs';

// Get All Occupants Saga
function* getOccupantsSaga(action) {
    try {
        const response = yield getOccupantsReq(action);
        if (response.success === true) {
            yield put({ type: GET_OCCUPANTS_SUCCESS, data: response });
        } else {
            yield put({ type: GET_OCCUPANTS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch occupants");
        }
    } catch (error) {
        yield put({ type: GET_OCCUPANTS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Get Occupant Details Saga
function* getOccupantDetailsSaga(action) {
    try {
        const response = yield getOccupantDetailsReq(action);
        if (response.success === true) {
            yield put({ type: GET_OCCUPANT_DETAILS_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_OCCUPANT_DETAILS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch occupant details");
        }
    } catch (error) {
        yield put({ type: GET_OCCUPANT_DETAILS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Create Occupant Saga
function* createOccupantSaga(action) {
    try {
        const response = yield createOccupantReq(action);
        if (response.success === true) {
            yield put({ type: CREATE_OCCUPANT_SUCCESS, data: response.data });
            toast.success(response.message || "Occupant created successfully");
            // Pass the created row back so callers can act on it (e.g. attach
            // documents against the fresh occupant_id) — matches the same
            // callback shape used elsewhere.
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: CREATE_OCCUPANT_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to create occupant");
        }
    } catch (error) {
        yield put({ type: CREATE_OCCUPANT_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Occupant Saga
function* updateOccupantSaga(action) {
    try {
        const response = yield updateOccupantReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_OCCUPANT_SUCCESS, data: response.data });
            toast.success(response.message || "Occupant updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: UPDATE_OCCUPANT_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update occupant");
        }
    } catch (error) {
        yield put({ type: UPDATE_OCCUPANT_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Delete Occupant Saga
function* deleteOccupantSaga(action) {
    try {
        const response = yield deleteOccupantReq(action);
        if (response.success === true) {
            yield put({ type: DELETE_OCCUPANT_SUCCESS, data: response.data });
            toast.success(response.message || "Occupant deleted successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: DELETE_OCCUPANT_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to delete occupant");
        }
    } catch (error) {
        yield put({ type: DELETE_OCCUPANT_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// ---------------- Occupant document sagas ----------------

function* uploadOccupantDocumentSaga(action) {
    try {
        const response = yield uploadOccupantDocumentReq(action);
        if (response.success === true) {
            yield put({ type: UPLOAD_OCCUPANT_DOCUMENT_SUCCESS, data: response.data, meta: { occupant_id: action?.data?.occupant_id } });
            toast.success(response.message || 'Document uploaded');
            if (action?.data?.onSuccess) action.data.onSuccess(response.data);
        } else {
            yield put({ type: UPLOAD_OCCUPANT_DOCUMENT_FAILURE, data: response.data });
            toast.error(response?.message || response?.data?.message || 'Upload failed');
            if (action?.data?.onError) action.data.onError(response);
        }
    } catch (error) {
        yield put({ type: UPLOAD_OCCUPANT_DOCUMENT_FAILURE, data: error });
        toast.error(error?.response?.data?.message || 'Upload failed');
        if (action?.data?.onError) action.data.onError(error);
    }
}

function* deleteOccupantDocumentSaga(action) {
    try {
        const response = yield deleteOccupantDocumentReq(action);
        if (response.success === true) {
            yield put({ type: DELETE_OCCUPANT_DOCUMENT_SUCCESS, data: { document_id: action?.data?.document_id } });
            toast.success(response.message || 'Document removed');
            if (action?.data?.onSuccess) action.data.onSuccess();
        } else {
            yield put({ type: DELETE_OCCUPANT_DOCUMENT_FAILURE, data: response.data });
            toast.error(response?.message || 'Delete failed');
        }
    } catch (error) {
        yield put({ type: DELETE_OCCUPANT_DOCUMENT_FAILURE, data: error });
        toast.error(error?.response?.data?.message || 'Delete failed');
    }
}

function* listOccupantDocumentsSaga(action) {
    try {
        const response = yield listOccupantDocumentsReq(action);
        if (response.success === true) {
            yield put({ type: LIST_OCCUPANT_DOCUMENTS_SUCCESS, data: response.data });
        } else {
            yield put({ type: LIST_OCCUPANT_DOCUMENTS_FAILURE, data: response.data });
        }
    } catch (error) {
        yield put({ type: LIST_OCCUPANT_DOCUMENTS_FAILURE, data: error });
    }
}

export default function* OccupantSaga() {
    yield takeLatest(GET_OCCUPANTS, getOccupantsSaga);
    yield takeLatest(GET_OCCUPANT_DETAILS, getOccupantDetailsSaga);
    yield takeLatest(CREATE_OCCUPANT, createOccupantSaga);
    yield takeLatest(UPDATE_OCCUPANT, updateOccupantSaga);
    yield takeLatest(DELETE_OCCUPANT, deleteOccupantSaga);
    yield takeLatest(UPLOAD_OCCUPANT_DOCUMENT, uploadOccupantDocumentSaga);
    yield takeLatest(DELETE_OCCUPANT_DOCUMENT, deleteOccupantDocumentSaga);
    yield takeLatest(LIST_OCCUPANT_DOCUMENTS, listOccupantDocumentsSaga);
}
